function roundToNearestMinute(date) {
  const d = new Date(date);
  d.setSeconds(0, 0);
  return d.getTime();
}
module.exports = { roundToNearestMinute };
